
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/statistik",
      function () {
        return require("private-next-pages/statistik/index.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/statistik"])
      });
    }
  